import(/* webpackMode: "eager", webpackExports: ["BlogIndexClient"] */ "/opt/buildhome/repo/app/(main)/blog/BlogIndexClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JournalNewsletter"] */ "/opt/buildhome/repo/components/blog/JournalNewsletter.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
